import React from 'react';
import PropTypes from 'prop-types';
import RichTextBase from '../rich-text/base';
import { OuterWrapper, ColumnWrapper, Column, Title } from './styles';
import { consistentString } from '../../utils/content-formatting';
import { Container } from '../layout';

const ThreeColumnRichText = ({
  backgroundColor,
  richText1,
  richText2,
  richText3,
  title,
  removeMarginBottom,
}) => (
  <OuterWrapper
    $greyBackground={backgroundColor === 'grey'}
    $removeMarginBottom={removeMarginBottom}
  >
    <Container>
      {title ? <Title>{title}</Title> : null}
      <ColumnWrapper>
        <Column>
          <RichTextBase richText={richText1} />
        </Column>
        <Column>
          <RichTextBase richText={richText2} />
        </Column>
        <Column>
          <RichTextBase richText={richText3} />
        </Column>
      </ColumnWrapper>
    </Container>
  </OuterWrapper>
);

export default ThreeColumnRichText;

ThreeColumnRichText.propTypes = {
  backgroundColor: PropTypes.string,
  title: PropTypes.string,
  richText1: PropTypes.object.isRequired,
  richText2: PropTypes.object.isRequired,
  richText3: PropTypes.object.isRequired,
  removeMarginBottom: PropTypes.bool,
};

export const ThreeColumnRichTextAssembly = ({ contentfulData }) => (
  <ThreeColumnRichText
    title={contentfulData.title}
    richText1={contentfulData.richText1}
    richText2={contentfulData.richText2}
    richText3={contentfulData.richText3}
    backgroundColor={consistentString(contentfulData.backgroundColor)}
    removeMarginBottom={contentfulData.removeMarginBottom}
  />
);

ThreeColumnRichTextAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
